import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CreatorSignup from './components/creator/CreatorSignup';
import CreatorLogin from './components/creator/CreatorLogin';
import DonationPage from './components/donation/DonationPage';
import CreatorDashboard from "./components/creator/CreatorDashboard";
import CreatorDonationReport from "./components/creator/CreatorDonationReport";
import PublicCastleView from "./components/creator/PublicCastleView";
import AdminTransfer from './components/AdminTransfer';
import DonatorSignup from './components/donation/DonatorSignup';
import DonatorLogin from './components/donation/DonatorLogin';
import DonatorDashboard from './components/donation/DonatorDashboard';
import VerifyEmail from './components/donation/VerifyEmail';
import DonatorManagement from './components/admin/DonatorManagement';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminLogin from './components/admin/AdminLogin';
import AdminSettings from './components/admin/AdminSettings';
import AdminUserManagement from './components/admin/AdminUserManagement';
import AdminDonationsLedger from './components/admin/AdminDonationsLedger';
import AdminReconciliation from './components/admin/AdminReconciliation';
import AdminRoute from './components/admin/AdminRoute';
import RecentTipsOverlay from './components/overlay/RecentTipsOverlay';
import TipAlertOverlay from './components/overlay/TipAlertOverlay';
import OverlayEditor from './components/overlay/OverlayEditor';
import SceneRenderer from './components/overlay/SceneRenderer';
import OnboardingWizard from './components/onboarding/OnboardingWizard';
import PendingApproval from './components/onboarding/PendingApproval';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';

// Root redirect component
const RootRedirect = () => {
  const redirectUrl = process.env.REACT_APP_ROOT_REDIRECT_URL || 'https://www.mycastle.gg/';
  window.location.href = redirectUrl;
  return null;
};

export default function App() {
  // Auto-detect base path based on hostname
  const getBasename = () => {
    // First check if env var is set (for flexibility)
    if (process.env.REACT_APP_BASE_PATH) {
      return process.env.REACT_APP_BASE_PATH;
    }
    // If running on app.mycastle.gg subdomain, no base path needed
    if (window.location.hostname === 'app.mycastle.gg') {
      return '';
    }
    // If running on mycastle.gg domain, use /app base path
    if (window.location.hostname === 'mycastle.gg' || window.location.hostname === 'www.mycastle.gg') {
      return '/app';
    }
    // Otherwise (localhost or DO app direct URL), no base path
    return '';
  };

  const basename = getBasename();

  // Debug logging
  console.log('hostname:', window.location.hostname);
  console.log('REACT_APP_BASE_PATH:', process.env.REACT_APP_BASE_PATH);
  console.log('basename:', basename);
  console.log('window.location.pathname:', window.location.pathname);

  return (
    <Router basename={basename}>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/tip/:username" element={<DonationPage />} />
        <Route path="/donate/:username" element={<DonationPage />} />
        <Route path="/creator-signup" element={<CreatorSignup />} />
        <Route path="/creator-login" element={<CreatorLogin />} />
        <Route path="/creator-dashboard" element={<CreatorDashboard />} />
        <Route path="/creator-donations" element={<CreatorDonationReport />} />
        <Route path="/manage/login" element={<AdminLogin />} />
        <Route path="/manage" element={
          <AdminRoute>
            <AdminDashboard />
          </AdminRoute>
        } />
        <Route path="/manage/transfer" element={
          <AdminRoute>
            <AdminTransfer />
          </AdminRoute>
        } />
        <Route path="/manage/donators" element={
          <AdminRoute>
            <DonatorManagement />
          </AdminRoute>
        } />
        <Route path="/manage/settings" element={
          <AdminRoute>
            <AdminSettings />
          </AdminRoute>
        } />
        <Route path="/manage/users" element={
          <AdminRoute>
            <AdminUserManagement />
          </AdminRoute>
        } />
        <Route path="/manage/donations" element={
          <AdminRoute>
            <AdminDonationsLedger />
          </AdminRoute>
        } />
        <Route path="/manage/reconciliation" element={
          <AdminRoute>
            <AdminReconciliation />
          </AdminRoute>
        } />
        <Route path="/donator-signup" element={<DonatorSignup />} />
        <Route path="/donator-login" element={<DonatorLogin />} />
        <Route path="/donator-dashboard" element={<DonatorDashboard />} />
        <Route path="/my-account" element={<DonatorDashboard />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/overlay/tips/:username" element={<RecentTipsOverlay />} />
        <Route path="/overlay/tipalert/:username" element={<TipAlertOverlay />} />
        <Route path="/overlay/editor/:sceneId" element={<OverlayEditor />} />
        <Route path="/overlay/scene/:username/:sceneName/:sceneId" element={<SceneRenderer />} />

        <Route path="/castle/:username" element={<PublicCastleView />} />
        <Route path="/onboarding" element={<OnboardingWizard />} />
        <Route path="/pending-approval" element={<PendingApproval />} />

        {/* Catch-all route for usernames - MUST be last */}
        <Route path="/:username" element={<DonationPage />} />
      </Routes>
    </Router>
  );
}
